// Centralized hostname detection.
// A single source of truth so routing, canonical URLs, and schema stay consistent.

export const LEES_HOSTS = [
  "leesheatingnwi.com",
  "www.leesheatingnwi.com",
];

export const CLEANING_HOSTS = [
  "sscleaningnwi.com",
  "www.sscleaningnwi.com",
];

export const CLEANING_CANONICAL_ORIGIN = "https://sscleaningnwi.com";
export const LEES_CANONICAL_ORIGIN = "https://leesheatingnwi.com";
export const LEES_FAVICON = "/lees-favicon-192.png";

export function getHost() {
  if (typeof window === "undefined") return "";
  return (window.location.hostname || "").toLowerCase();
}

export function isLeesHost(hostname) {
  const h = (hostname || getHost()).toLowerCase();
  return LEES_HOSTS.includes(h);
}

export function isCleaningHost(hostname) {
  const h = (hostname || getHost()).toLowerCase();
  return CLEANING_HOSTS.includes(h);
}

// Canonical origin for the current host — Lees for Lees hosts,
// SS Cleaning for everything else (incl. preview / Emergent subdomains,
// so canonical never points at a preview URL).
export function canonicalOrigin(hostname) {
  return isLeesHost(hostname) ? LEES_CANONICAL_ORIGIN : CLEANING_CANONICAL_ORIGIN;
}

// HVAC routes: root-level on the Lee's domain, nested under /hvac everywhere else.
export function hvacPath(path = "/", hostname) {
  if (isLeesHost(hostname)) return path;
  return path === "/" ? "/hvac" : `/hvac${path}`;
}

// Cleaning-site cross-promo target. Keep "/hvac" while leesheatingnwi.com still
// forwards to /hvac; switch to LEES_CANONICAL_ORIGIN once the domain is connected directly.
export const HVAC_PROMO_HREF = "https://leesheatingnwi.com/";

// Build a full canonical URL for a given path on the current brand.
// On Lees hosts, path "/hvac" and path "/" both resolve to Lees root
// (because Lees serves HVACLanding at /).
export function canonicalUrl(path, hostname) {
  const origin = canonicalOrigin(hostname);
  const h = (hostname || getHost()).toLowerCase();
  // On Lees domain, the HVAC landing lives at "/", so collapse "/hvac" -> "/"
  if (isLeesHost(h) && (path === "/hvac" || path === "/hvac/")) {
    return `${origin}/`;
  }
  if (!path || path === "/") return `${origin}/`;
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}
